import { mapActions } from 'vuex'
import { ADD_TOAST_MESSAGE } from 'vuex-toast'

export default {

	methods: {
		...mapActions({
	      addToast: ADD_TOAST_MESSAGE
	    }),

		displayError (error) {
			if (typeof error === 'string' || error instanceof String) {
				this.addToast({
				  text: error,
				  type: 'danger',
				  dismissAfter: 5000
				})
			} else {
				for(let key in error) {
				  this.addToast({
				    text: error[key][0],
				    type: 'danger',
				    dismissAfter: 5000
				  })
				}
			}
		},

		displaySuccess (text) {
			this.addToast({
			  text,
			  type: 'success',
			  dismissAfter: 5000
			})
		}
	}
}